import { Feedback } from '../../feedback/add_order_feedback.request';

export type TOrder = {
  id: number;
  personId: number;
  date: string;
  status: EOrderStatus;
  description: string;
  tripId: number;
  stationFromId: number;
  stationToId: number;
  tickets: TOrderTicket[];
  ticketQr: string;
  payType: number;
  paySumm: number;
  payReturnUrl: string;
  payConfirmationUrl: string;
  payConfirmationStatus: number;
  payRemoteId: number;
  payCheckDate: string;
  refundStopDelay?: number;
  feedback: Feedback | null;
};

/*
Статус заказа
 0 - новый
 1 - обработан успешно
 2 - обработан с ошибкой
 3 - забронирован
 4 - отменен, деньги возвращены
*/
export enum EOrderStatus {
  new = 0,
  success = 1,
  error = 2,
  booked = 3,
  canceled = 4,
}

export type TOrderTicket = {
  id: number;
  orderId: number;
  mainTicketId: number;
  personId: number;
  date: string;
  refundDate: string;
  status: EOrderStatus;
  description: string;
  tripId: number;
  tariffId: number;
  summ: number;
  stationFrom: TStationName;
  stationTo: TStationName;
  wagonNum?: number;
  seatNum?: number;
  payType: number;
  paySumm: number;
  departureTime: string;
  departureEstimated: boolean;
  arrivalTime: string;
  arrivalEstimated: boolean;
  qr: string;
};

export type TStationName = {
  id: number;
  nameHy: string;
  nameEn: string;
  nameRu: string;
};
